(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("workingSchedulesActions", workingSchedulesActionsFactory);

  /** @ngInject */
  function workingSchedulesActionsFactory(
    $q,
    api,
    dispatcher,
    ActionTypesEnum,
    $translate
  ) {
    return {
      getSiteHolidays: getSiteHolidays,
      createSiteHolidays: createSiteHolidays,
      updateSiteHolidays: updateSiteHolidays,
      deleteSiteHolidays: deleteSiteHolidays,
      deleteHoliday: deleteHoliday,
      getWorkingSchedules: getWorkingSchedules,
      updateWorkingSchedules: updateWorkingSchedules,
      propagateWorkingSchedules: propagateWorkingSchedules,
      getSiteDetailsById: getSiteDetailsById,
      updateSiteDetails: updateSiteDetails
    };

    function getSiteHolidays(siteId) {
      var deferred = $q.defer();
      api.getSiteHolidays(siteId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function createSiteHolidays(siteId, data) {
      var deferred = $q.defer();
      api.createSiteHolidays(siteId, data).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("SITE_HOLIDAY_SUCCESSFULLY_CREATED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function updateSiteHolidays(siteId, data) {
      var deferred = $q.defer();
      api.updateSiteHolidays(siteId, data).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("SITE_HOLIDAY_SUCCESSFULLY_UPDATED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function deleteSiteHolidays(siteId) {
      var deferred = $q.defer();
      api.deleteSiteHolidays(siteId).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("SITE_HOLIDAY_SUCCESSFULLY_DELETED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function deleteHoliday(siteId, holidayId) {
      var deferred = $q.defer();
      api.deleteHoliday(siteId, holidayId).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("HOLIDAY_SUCCESSFULLY_DELETED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getWorkingSchedules(siteId) {
      var deferred = $q.defer();
      api.getWorkingSchedules(siteId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function updateWorkingSchedules(siteId, data) {
      var deferred = $q.defer();
      api.updateWorkingSchedules(siteId, data).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("SITE_HOLIDAY_SUCCESSFULLY_UPDATED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function propagateWorkingSchedules(siteId, path) {
      var deferred = $q.defer();
      api.propagateWorkingSchedules(siteId, path).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getSiteDetailsById(siteId) {
      var deferred = $q.defer();
      api.getSiteDetailsById(siteId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function updateSiteDetails(siteId, data) {
      var deferred = $q.defer();
      api.updateSiteDetails(siteId, data).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("SITE_DETAILS_SUCCESSFULLY_UPDATED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

  }
})();
